<div class="contact-documents-container field-font-small" fxLayout="row">
    <div fxFlex="grow" *ngIf="contactType == 'RX'">
        <app-contact-rx-serie [contact]="contact"></app-contact-rx-serie>
    </div>
    <div fxFlex="grow">
        <ngx-file-drop #filedrop dropZoneLabel="Déposez vos fichiers ici" (onFileDrop)="dropped($event)" 
            (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)">
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                <div class="alldocuments">
                    <div class="document-container" *ngFor="let document of documents" (click)="openDocument(document);">
                        <div class="document-icon" [ngClass]="{'document-icon-pdf' : document.type == 'pdf'}" [matTooltip]="document.filename">
                            <fa-icon *ngIf="document.type == 'pdf'" [icon]="['fas','file-pdf']" size="4x"></fa-icon>
                            <fa-icon *ngIf="document.type == 'png' || document.type == 'jpg' || document.type == 'jpeg'" [icon]="['fas','file-image']" size="4x"></fa-icon>
                        </div>
                        <div class="document-templatename">{{ document.templateName }}</div>
                    </div>
                </div>
            </ng-template>
        </ngx-file-drop>        
    </div>
    <div fxFlex="220px" class="contact-documents-title">
        <mat-toolbar color="primary" class="item-panel-subtoolbar">
            <span>Documents</span>
        </mat-toolbar>
        <app-document-template-list (selected)="selectTemplate($event)"></app-document-template-list>
        <button [disabled]="!template" (click)="generateDocument()" mat-stroked-button>Générer&nbsp;&nbsp;<fa-icon [icon]="['fas','file-invoice']" size="lg"></fa-icon></button>
        <button (click)="openFileSelector()" mat-stroked-button>Ajouter&nbsp;&nbsp;<fa-icon [icon]="['fas','file']" size="lg"></fa-icon></button>
    </div>
</div>